export default {
  tocTitle: "📑 目錄",
  t1: "使用条款",

  c1: `<p>
    <span style="font-weight: bold;">本协议自您注册使用本服务之日（“生效日期”）</span>起生效。注册使用本服务即表示您以个人身份或代表您的组织同意本协议的条款和条件。您声明并保证您拥有约束您本人和/或您的组织签署本协议的法律权限，并且您已阅读并理解本协议。如果您不具备此类权限，或者您或您的组织不同意本协议的条款，则您不应接受本协议。平台可能会对访问本服务及某些功能附加某些要求或条件，包括但不限于要求提供客户信息以及满足特定的资格要求。
</p>`,
  t2: "定义",
  c2: `<p>
    <strong>“一方”</strong>是指控制另一方、受另一方控制或与另一方共同受控的任何个人或实体，其中“控制”是指拥有百分之五十（50%）或以上已发行有投票权的证券。
</p>
<p>
    <strong>“授权用户”</strong>是指符合以下条件的指定个人：(a) 是客户或客户关联平台的雇员、代表、顾问、承包商或代理人；(b) 已根据本协议获得使用服务的授权；以及 (c) 已获得客户提供的用户标识和密码。
</p>
<p>
    <strong>“承诺期”</strong>是指从服务生效日期开始，到约定期限结束为止的期间，客户已承诺按照本协议所附订单中规定的特定合同期限履行服务。
</p>
<p>
    <strong>“客户数据”</strong>是指客户或授权用户通过服务提供或提交的任何电子数据或材料。
</p>
<p>
    <strong>“知识产权”</strong>是指所有当前和未来的全球知识产权，包括但不限于所有专利、版权、商标、服务标记、商号、域名权、专有技术和其他商业秘密权，以及所有其他知识产权和类似形式的保护，以及上述任何权利的所有申请和注册。
</p>
<p>
    <strong>“服务”</strong>是指Aetrivol平台托管软件应用程序的适用版本，包括任何相关的 GPU 计算和管理服务。
</p>
<p>
    <strong>“订阅期限”</strong>是指，除非客户在平台网页上注册服务时另有规定，否则是指持续的订阅期限（一年），在此期间，授权用户可以根据本协议的条款使用服务；或者是指相关合同协议中规定的日期和其他详情所定义的特定合同期限（“承诺期”）。
</p>
<p>
    <strong>“支持服务”</strong>是指平台在订阅期内向客户提供的维护和支持服务，如下文第 2.3 节所述。
</p>`,
  m3: "许可和支持服务",
  t3: "服务的许可和访问权限",
  c3: `<p>
    平台将托管服务，并在订阅期内根据本协议的条款和条件向客户提供服务。除非客户选择付费软件版本或同意签订承诺期协议，否则客户可免费使用服务。客户对服务的访问和使用不得超出服务规定的限制，且不得干扰其他用户对服务的使用。平台可自行决定不时更新服务的内容、功能和用户界面，并可自行决定随时终止或暂停全部或部分服务，包括在订阅期内；但前提是，平台将在终止服务或在订阅期内大幅降低服务功能之前至少提前十五 (15) 天通知客户。平台授予客户一项有限的、非独占的、不可再许可的、不可转让的（除非本协议另有明确规定）权利，允许客户在订阅期内访问和使用本服务及其文档，且仅限用于客户的内部业务用途。客户可允许其关联平台根据本协议使用和访问本服务及其文档，但客户应负责确保所有关联平台遵守本协议。为避免疑义，Aetrivol平台托管软件应用程序服务仅以托管方式提供，客户不得独立拥有、运行或安装本服务。
</p>`,

  t4: "限制",
  c4: `<p>
    除非本协议另有明确规定，否则客户不得且不得允许任何第三方：(a) 以任何方式转授许可、出售、转让、分配、分发或以其他方式授予或允许任何人在未经授权用户订阅的情况下访问或使用服务，或将服务用于商业用途；(b) 复制、修改服务或基于服务创建衍生作品；(c) 对服务进行逆向工程或反编译（除非适用法律允许，且仅在平台在收到客户的书面请求后合理时间内未能提供允许的接口信息的情况下）；(d) 复制服务的任何特性、功能或图形；(e) 允许多个授权用户共享或使用授权用户订阅（但授权用户订阅可以重新分配给新的授权用户，以替换因终止雇佣关系或其他工作状态或职能变更而不再使用服务的个人）。或 (f) 访问或使用本服务：(i) 发送、存储或作为基础设施以协助发送侵权、淫秽、威胁性或其他非法、不道德和/或潜在有害的材料，包括但不限于煽动暴力、诽谤性材料、公共虚假信息宣传活动和/或侵犯第三方隐私权的材料；(ii) 违反适用法律；(iii) 发送或存储包含软件病毒、蠕虫、特洛伊木马或其他有害计算机代码、文件、脚本或代理的材料；(iv) 以干扰或破坏本服务（或其中包含的数据）的完整性或性能的方式；(v) 未经授权访问本服务（包括未经授权的功能）或其相关系统或网络；(vi) 以未经授权的方式规避帐户的既定限制；(vii) 滥用推荐、促销或积分以获取超出付费范围的功能；或 (viii) 通过平台公开支持的界面以外的任何方式访问、搜索或创建服务帐户（例如，“抓取”或批量创建帐户）。
</p>`,

  t5: "支持服务",
  c5: `<p>
    在订阅期内，平台将为服务提供电子邮件支持，客户可通过发送电子邮件至aetrivol@aetrivol.com向平台提出请求。客户同意仅就本协议许可的服务请求支持。
</p>
<p>
    <strong>使用限制</strong>。使用本服务须遵守任何使用限制，包括功能限制，这些限制已在客户注册本服务的平台网页上列明。如果客户超出任何此类限制，客户应立即通知平台，并与平台合作，尽快调整其使用方式以符合限制。平台可能会定期核实客户对本服务的使用是否在适用的使用限制范围内，客户应根据平台不时的要求，及时准确地证明和/或提供其遵守适用使用限制的证据。
</p>`,

  t6: "客户对客户数据和授权用户的责任",
  c6: `<p>
    客户同意，一旦发现任何未经授权访问授权用户帐户的情况，应立即通知平台。客户全权负责决定其向服务提交哪些数据，并负责获取提交客户数据和处理指令所需的所有必要同意和许可，以及确保客户数据的准确性、质量和合法性。客户还需对授权用户在本协议项下的行为和不作为、授权用户对服务的所有使用以及授权用户违反本协议的行为承担责任。客户应采取合理措施防止任何已知或疑似未经授权使用授权用户访问凭证的情况，并应立即通知平台。
</p>`,

  t7: "知识产权与所有权",
  c7: `<p>
    <strong>· 所有权</strong>。无论本协议另有规定，本服务及文档、其所有副本及部分内容，以及其中包含的所有知识产权（包括但不限于其衍生作品），均为且将始终为本平台独有财产。除本协议明确授权外，客户不得使用（且不得允许任何第三方使用）本服务、文档或其任何部分。
</p>
<p>
    <strong>· 客户数据许可</strong>。客户授予平台一项全球范围内的非独占许可，允许平台在合理必要的情况下托管、复制、处理、传输和展示客户数据，以便平台根据本协议提供服务。除本有限许可外，客户与平台之间，客户拥有客户数据的所有权利、所有权和权益，包括所有相关的知识产权。
</p>
<p>
    <strong>· 客户使用</strong>。客户承认并同意：(1)Aetrivol平台可以利用客户反馈以及从客户使用服务中获得的知识，客户同意无偿提供这些信息；(2) Aetrivol平台对与服务相关的所有知识产权，以及因客户使用平台而产生的任何改进、变更和/或衍生作品，拥有独家所有权；(3) 客户授予Aetrivol平台在使用平台时展示客户平台名称和徽标的权限。
</p>
<p>
    <strong>· 汇总信息的使用</strong>。平台可能会收集和汇总从服务运营中获得的数据（“汇总数据”），并且平台可能会将此类汇总数据用于运营平台业务、监控服务性能和/或改进服务；但前提是，平台对汇总数据的使用不会泄露任何客户数据、客户机密信息或授权用户的个人身份信息。
</p>`,

  t8: "付款；承诺",
  c8: `<p>
    客户同意按届时有效的价格向平台支付其及其授权用户所购买产品的全部费用。客户进一步授权平台从其选择的付款方式中扣除任何定期购买或到期款项。平台将根据需要，在购买价格中添加销售税。
</p>
<p>
    若平台认定客户违反了订阅期和承诺期内的付款义务，平台可在通知客户后立即暂停客户及其授权用户访问或使用全部或部分服务的权利。若平台已向客户开具发票，但客户未在到期日支付款项，则在不限制平台其他权利或补救措施的前提下，任何欠款均可能按每月未付余额的1.5%或法律允许的最高利率（以较低者为准）计收滞纳金。上述条款允许平台在未来更改付款方式，例如改为预付款或缩短付款期限。
</p>
<p>
    如果客户逾期未支付任何费用，则客户授权平台通过客户记录中的任何付款方式收取到期费用。如果平台无法收取款项，平台可在不影响其其他权利和补救措施的情况下，暂停或终止客户对服务或账户的访问权限，并可冻结相关账户中的资金，直至到期款项全部付清。
</p>
<p>
    如果客户未能在本协议规定的付款期限内支付任何应付款项，平台有权将未偿债务委托给第三方催收机构，或采取任何必要的法律措施以追讨欠款。客户应负责支付平台因追讨逾期款项而产生的所有费用和成本，包括但不限于催收机构费用、诉讼费用、律师费以及平台收取的任何相关管理费。管理费应涵盖平台在催收过程中产生的费用，包括但不限于行政成本和管理费用。
</p>`,
  t9: "期限；终止",
  c9: `<p>
    <strong>· 生效日期和期限。</strong>本协议自生效日起生效。除非根据本协议第5条的规定提前终止，否则本协议将持续有效至订阅期结束。除非一方在订阅期结束前十五（15）天以上通知另一方，否则每个订阅期将自动续期，续期期限与原订阅期相同。
</p>
<p>
    <strong>· 因故终止。</strong>任何一方均可向另一方发出书面通知立即终止本协议：(a) 如果另一方违反或未能履行或遵守本协议的任何实质性条款或条件，且在收到另一方关于该违约行为的书面通知后三十 (30) 天内仍未纠正该违约行为，即使平台已事先告知客户服务交付存在延迟；或 (b) 如果另一方 (i) 终止或暂停其业务，(ii) 成为联邦或州法律规定的任何破产程序的当事人，(iii) 破产或受托人、接管人或类似机构的直接控制，或 (iv) 已清算或解散（无论自愿或非自愿）。为避免疑义，本协议的终止将导致所有订阅条款的终止。
</p>
<p>
    <strong>· 为方便起见而终止；暂停。</strong>任何一方均可出于任何原因或无任何原因终止本协议，但须至少提前十五 (15) 天以书面形式通知另一方，以终止当前订阅期。如果客户设有承诺期，则客户仅在约定期限届满或已根据本协议附件订单中约定的期限全额支付承诺期费用后方可终止服务。此外，如果客户违反（或平台有理由怀疑客户违反）第 2.2 条或侵犯平台知识产权，平台可立即停止或暂停客户对服务的访问。
</p>
<p>
    <strong>· 终止的效力。</strong>本协议因任何原因到期或终止后：(a) 平台提供支持服务的义务及服务将终止；(b) 客户及其授权用户使用服务的所有权利将终止；(c) 本协议第 4.3、6.4、7、8、9 和 10 条的规定在本协议到期或终止后仍然有效。
</p>
<p>
    <strong>协议终止或到期后客户数据的处理。</strong>客户同意，本协议终止后，平台可立即停用客户的服务账户，并且平台有权从平台网站删除这些账户及其所有客户数据，除非法律禁止。客户确认并同意，其有责任在本协议到期前从服务中取回客户数据。
</p>`,
  t10: "声明与保证",
  c10: `<p>
    <strong>· 各方均声明</strong>并保证其有权订立本协议，且其各自提供和使用服务均符合适用于该方的法律。
</p>
<p>
    <strong>· 符合文档要求。</strong>平台保证，在订阅期内，服务将基本符合适用文档的要求。如果发生上述保证的重大违约，客户的唯一补救措施以及平台承担的全部责任是客户通过支持服务请求平台的协助，平台将根据其在第 2.3 条（“支持服务”）项下的义务提供该等协助。
</p>
<p>
    <strong>· 恶意代码。</strong>本平台保证，据其所知，本服务不含软件病毒、蠕虫、特洛伊木马或其他旨在造成损害的代码、文件、脚本或代理，并且本平台不会故意引入此类病毒、蠕虫、特洛伊木马或其他代码、文件、脚本或代理。
</p>
<p>
    <strong>· 免责声明。</strong>除本第6条规定的专属保证外，在适用法律允许的最大范围内，本服务按“现状”提供，不提供任何形式的保证，且本平台对本服务、文档或支持服务不作任何明示、默示、法定或其他形式的保证。本平台明确否认所有其他明示或默示的保证，包括但不限于适销性、特定用途适用性、不侵权、交易习惯或行业惯例产生的默示保证，且所有此类保证均在法律允许的最大范围内予以排除。此外，本平台不保证本服务不会出现错误，也不保证服务的使用不会中断。
</p>`,
  t11: "保障",
  c11: `<p>
    <strong>· 平台。</strong>在遵守本第 7 条其余条款和第 8 条规定的责任限制的前提下，平台将：(a) 就任何第三方提出的服务侵犯该第三方商标或版权（在客户使用服务的司法管辖区内可强制执行）或盗用商业秘密（但仅限于该等盗用并非由客户行为造成的情况）的索赔（“侵权索赔”）为客户进行辩护；以及 (b) 就平台同意的任何侵权索赔和解或有管辖权的法院最终判决客户向该第三方支付的任何损害赔偿金，向客户作出赔偿并支付该等和解金。对于基于以下原因的任何索赔，平台在本第 7 条或其他条款下不承担任何义务和责任：(a) 非由平台或代表平台执行或未按照客户规格执行的任何服务修改； (b) 将本服务与任何客户数据或任何客户或第三方产品、服务、硬件、数据、内容或业务流程（非本平台提供）结合、操作或使用，若非此种结合，则不会构成侵权；(c) 未按照本协议及相关文档的条款和条件使用本服务；或 (d) 客户或任何授权用户未按照本协议许可的方式使用本服务。本第 7 条规定了客户就任何侵权索赔或诉讼可获得的唯一且排他的救济以及本平台承担的全部责任。
</p>
<p>
    <strong>· 补救措施。</strong>如果服务成为或平台认为可能成为侵权索赔的对象，平台可自行选择 (i) 为客户取得根据本协议使用服务的权利； (ii) 替换或修改服务，使其不再侵权；或 (iii) 终止客户使用服务的权利并停止相关的支持服务。
</p>
<p>
    <strong>· 客户应为</strong>平台及其关联平台，以及其董事、高级职员、员工、代理人和许可人进行辩护、赔偿并使其免受损害，使其免于承担因以下原因引起的任何索赔而最终判决的任何损害赔偿和费用（包括受偿方产生的合理律师费和费用）：（i）客户使用服务或（ii）客户数据；但如果适用索赔是由于平台违反本协议而引起的，则客户在本第 7.3 条项下不承担任何义务。
</p>
<p>
    <strong>· 赔偿程序。</strong>各方的赔偿义务以受偿方满足以下条件为前提：(a) 及时以书面形式通知赔偿方索赔；(b) 将索赔的抗辩和和解的最终决定权完全交给赔偿方；以及 (c) 应赔偿方的要求并由赔偿方承担费用，向赔偿方提供与索赔相关的所有可用信息和协助。受偿方可以自费参与索赔的抗辩（无需偿还）。除非承认、让步、和解或妥协包含另一方就该索赔承担的所有责任且无条件地免除该等责任，否则任何一方均不得承认责任或同意任何判决，亦不得对任何索赔做出让步、和解或妥协。
</p>`,
  t12: "责任限制",
  c12: `<p>
    <strong>· 损害赔偿免责；</strong>责任上限。在任何情况下，任何一方或其关联平台或许可方均不承担本协议项下任何后果性、附带性、特殊性、间接性、惩罚性或惩戒性损害赔偿责任，包括但不限于利润损失、使用损失、业务中断、数据丢失、收入损失、商誉损失、生产损失、预期节省损失或替代商品或服务的采购成本，无论该等损害赔偿是因违约还是侵权行为（包括过失）所致，即使一方已被告知可能发生该等损害赔偿。除因第7条（“赔偿”）项下的义务而产生的责任（该等责任的累计限额为十万美元（100,000美元））外，平台在本协议项下产生的全部累计责任在任何情况下均不得超过一万美元（10,000美元）。本第8.1条中的任何内容均不应被视为限制任何一方因故意不当行为、重大过失、欺诈或侵犯另一方知识产权而应承担的责任。
</p>
<p>
    <strong>· 责任限制公平合理。</strong>各方均承认，本第 8 条规定的责任限制反映了双方在本协议项下的风险分配，并且，如果没有这些责任限制，本协议的经济条款将大不相同。
</p>`,
  t13: "机密信息",
  c13: `<p>
    <strong>· 保密。</strong> “保密信息”指本协议、服务、平台定价信息、平台技术信息、客户数据以及一方（“披露方”）根据本协议向另一方（“接收方”）披露的任何其他信息，且该等信息被指定为保密信息或根据信息的性质和披露情况应被合理理解为保密信息。接收方仅可将披露方的保密信息用于履行其在本协议项下的义务或行使其权利。未经披露方事先书面同意，接收方不得向任何第三方披露或允许披露披露方的保密信息，但接收方仅可将披露方的保密信息披露给其需要知悉该等信息且已根据与本协议一致的保密协议以书面形式承诺对该等信息保密的接收方员工和/或分包商。接收方同意尽到应有的注意义务，保护披露方的保密信息免遭未经授权的使用和披露，且在任何情况下，其注意义务的程度均不得低于合理人士应尽的注意义务。上述规定不适用于以下任何信息：(a) 披露方告知接收方时已属于公共领域的信息；(b) 披露方告知接收方后，因接收方无过错而进入公共领域的信息；(c) 披露方告知接收方时，接收方已无保密义务地持有该信息；(d) 披露方告知接收方后，接收方合法地无保密义务地将该信息告知接收方；(e) 接收方的雇员或代理人独立开发，且未参考披露方告知接收方的任何信息。或 (f) 根据本协议的条款明确允许披露。
</p>
<p>
    <strong>· 强制披露。</strong>如果接收方根据法院或其他政府机构的有效命令进行披露，且接收方事先以书面形式通知披露方，以便披露方寻求对该信息进行保密处理，则接收方不会违反第 9.1 条的规定。
</p>
<p>
    <strong>· 反馈。</strong>如果客户提供任何与服务或支持服务相关的建议、推荐或其他反馈（统称为“反馈”），则客户授予平台一项免版税、已全额支付、可再许可、可转让（尽管有第 10.1 条（“转让”）的规定）、非独占、不可撤销、永久的全球性权利和许可，以制作、使用、销售、要约销售、进口和以其他方式利用反馈（包括将此类反馈无限制地纳入服务中）。
</p>
<p>
    <strong>· 敏感数据。</strong>客户同意，未经平台事先书面批准，不得向本服务提交以下类型的信息：政府签发的身份识别号码、消费者金融账户信息、信用卡和支付卡信息、个人健康信息，或根据适用法律被视为“敏感”的信息（例如种族或民族血统、政治观点或宗教或哲学信仰），或居住在欧洲经济区 (EEA) 的数据主体的个人数据（如欧洲议会和理事会 2016 年 4 月 27 日关于在处理个人数据方面保护自然人以及此类数据自由流动的 (EU) 2016/679 号条例所述）。如果客户希望向本服务提交任何此类欧洲个人数据，客户应通知平台，并且双方可在向本服务提交此类个人数据之前，与平台签订单独的数据处理协议（包括欧盟委员会关于向位于无法确保足够数据保护水平的第三国的处理者传输个人数据的标准合同条款）。客户声明并保证，其已获得数据主体提交和处理个人数据所需的所有必要同意和许可。
</p>`,
  t14: "一般的",
  c14: `<p>
    <strong>· 转让。</strong>未经另一方事先书面同意，任何一方均不得全部或部分转让本协议。但以下情况无需事先获得另一方同意：(i) 将本协议全部转让给能够履行转让方在本协议项下义务的关联平台；或 (ii) 在转让方合并、收购或出售其全部或绝大部分资产的情况下，将本协议全部转让给权益继承人，但前提是受让人已同意受本协议所有条款的约束，且已全额支付应付给另一方的所有费用。如果客户被本平台的直接竞争对手收购、将其绝大部分资产出售给本平台的直接竞争对手，或发生有利于本平台直接竞争对手的控制权变更，则本平台可发出书面通知立即终止本协议。
</p>
<p>
    <strong>· 反腐败。</strong>各方承认其知悉、理解并已遵守且将遵守所有适用的美国和外国反腐败法律，包括但不限于美国《反海外腐败法》（“FCPA”）和英国《反贿赂法》。
</p>
<p>
    <strong>· 通知。</strong>发送给任何一方的通知将通过一级邮件、隔夜快递或预付邮资的方式寄送至本协议首页所列的该方地址，并于寄出后七十二 (72) 小时或确认送达或收到之日（以较早者为准）视为已送达。客户应将通知发送至平台法务部，并抄送至aetrivol@aetrivol.com。任何一方均可根据本第 10.3 条的规定，提前至少三十 (30) 天以书面形式通知另一方，随时更改其在本条项下的通知地址。
</p>
<p>
    <strong>· 同意接收电子通讯。</strong>使用本网站和/或服务，即表示您同意接收我们发送的某些电子通讯，详情请参阅我们的隐私政策。请阅读我们的隐私政策，了解更多关于我们电子通讯做法的信息。您同意，我们以电子方式发送给您的任何通知、协议、披露或其他通讯均满足任何法律通讯要求，包括书面通讯的要求。
</p>
<p>
    <strong>· 不放弃权利。</strong>任何一方未能坚持或强制另一方履行本协议的任何条款，或未能行使本协议项下的任何权利或救济，均不应被解释或视为该方放弃或放弃在任何情况下主张或依赖该条款、权利或救济的权利。
</p>
<p>
    <strong>· 适用法律。</strong>本协议以及因本协议或其标的物或订立而产生或与之相关的任何争议或索赔（包括非合同争议或索赔）均应受英格兰和威尔士法律管辖并按其解释。各方不可撤销地同意，英格兰和威尔士法院对因本协议或其标的物或订立而产生或与之相关的任何争议或索赔（包括非合同争议或索赔）拥有专属管辖权。
</p>
<p>
    <strong>· 可分割性。</strong>如果本协议的任何条款被有管辖权的法院认定为无效或不可执行，则该条款将被替换为最能体现双方意图的有效条款，且本协议的其余条款将继续完全有效。
</p>
<p>
    <strong>· 双方关系。</strong>本协议中的任何内容均不应被解释为在双方之间建立代理、合伙或合资关系。任何一方均无权代表另一方承担或创设任何义务，亦无权作出任何明示或默示的陈述或保证，或以任何方式约束另一方。各方可根据具体情况将另一方称为客户或供应商。
</p>
<p>
    <strong>· 完整协议；签署。</strong>本协议构成客户与平台之间的完整协议，并取代双方此前或同时就本协议标的物达成的所有书面或口头提议、报价、谈判、讨论或协议。如果本协议的条款与本协议中提及的任何其他文件发生冲突，则以本协议为准。客户订单文件上的任何预印条款或其中提及或链接的条款均不影响本协议的条款，并在此予以拒绝，即使该等客户订单文件已由平台签署。本协议可签署多份副本，所有副本共同构成一份具有法律约束力的协议。双方特此同意使用电子签名签署本协议，并进一步同意，本协议的电子签名与手写签名具有同等的法律效力。
</p>`,
};
